import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'
// TODO: Check if a specific image is needed for the 'Building on the Relationship' slides or if a generic one or icon would be better.
// import CboPlaceholderImage from 'assets/toolkit/community/community_resources_placeholder.png';

interface Breadcrumb {
  label: string
  path: string
}

export const CommunityBasedOrganizationsDetailPage: React.FC = () => {
  const pageTitle = 'Community Based Organizations'
  const breadcrumbs: Breadcrumb[] = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Community', path: '/toolkit/community' },
    {
      label: 'Community-Based Resources',
      path: '/toolkit/community/community-based-resources'
    },
    {
      label: pageTitle,
      path: '/toolkit/community/community-based-organizations-detail'
    }
  ]

  // TODO: Replace with actual hosted PDF URLs
  const pdfDownloads = [
    {
      title: 'Release of Information Example',
      url: 'https://www.dropbox.com/scl/fi/6z91zfikopmpf8ev3tdvu/SCFMN-Release-of-Information_FINAL.pdf?rlkey=grclxm4zsk1xutfwvcmeaajbb&dl=0&dl=1'
    },
    {
      title: 'Join our mailing list Example',
      url: 'https://www.dropbox.com/scl/fi/f6k0aksxji94cn46dtmdh/Join-our-SCFMN-mailing-list_FINAL_.pdf?rlkey=wm1wphpe2t3emskdzv8x7u37t&dl=0&dl=1'
    },
    {
      title: 'Registration Form Example',
      url: 'https://www.dropbox.com/scl/fi/4sc0lrypde20h4fc5f7eg/CSCF-PA-Registration-Form.pdf?rlkey=thlx4wokwt1w93s72mewtklnt&dl=0&dl=1'
    }
  ]

  return (
    <ToolkitPageLayout title={pageTitle} breadcrumbs={breadcrumbs}>
      <div className="prose max-w-none text-[#3C2416]">
        <p className="text-lg mb-6">
          Review video on &quot;Importance of Community Based
          Organizations&quot;:
        </p>
        <div className="aspect-w-16 aspect-h-9 mb-8 rounded-lg overflow-hidden shadow-lg">
          {/* TODO: Host video and update src */}
          <iframe
            src="https://www.dropbox.com/scl/fi/29bod8cqxjp92t6yt243i/zoom_01.mp4?rlkey=9o6n4mhrgy03hheq64ec742iu&dl=0&dl=1"
            title="Importance of Community Based Organizations"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-full"
          ></iframe>
        </div>

        <p className="text-lg mb-6">
          Review these slides on &quot;Building on the Relationship With
          Community Based Organizations&quot;:
        </p>
        <figure className="mb-8 p-4 border rounded-lg shadow-md bg-gray-50">
          <a
            href="https://docs.google.com/presentation/d/e/2PACX-1vQSI8jvFCKDaRdoWzLvu7_1B8RJYJXsmXdwa0JzuIzrw3VBFvMFhEn3zf58N-fMEg/pub?start=false&loop=false&delayms=3000"
            target="_blank"
            rel="noopener noreferrer"
            className="block hover:opacity-80 transition-opacity"
          >
            {/* TODO: Replace with actual image if available or a more suitable placeholder/icon */}
            <img
              src="https://www.dropbox.com/scl/fi/ulsvtriqvaeebrn1l6kni/Screen-Shot-2021-12-23-at-10.32.43-AM-1024x575.png?rlkey=62do9qew8wko8nlhftcbds7kt&dl=0&dl=1"
              alt="Building on the Relationship With Community Based Organizations slides preview"
              className="w-full h-auto rounded shadow-sm mb-2"
            />
            <figcaption className="text-sm text-center text-gray-700">
              Building on the Relationship With Community Based Organizations
            </figcaption>
          </a>
        </figure>

        <h2 className="text-2xl font-semibold text-[#142841] mb-4">
          What if I do not have a community based organization?
        </h2>
        <figure className="mb-8 p-4 border rounded-lg shadow-md bg-gray-50">
          <a
            href="https://docs.google.com/document/d/e/2PACX-1vQZK7IdG_lgbqPVD60AxDeaRdGnh9zqV3Z415jIUtDq2E2hNWxYW0crWRfVmXpcAg/pub"
            target="_blank"
            rel="noopener noreferrer"
            className="block hover:opacity-80 transition-opacity"
          >
            <img
              src="https://www.dropbox.com/scl/fi/l67px1c9tz4d6qrz49a7p/Screen-Shot-2021-12-23-at-10.39.23-AM-1024x906.png?rlkey=0shut9dnta6uhhxmbc6rk7cr1&dl=0&dl=1"
              alt="Checklist for Tips on Establishing an SCD support group preview"
              className="w-full h-auto rounded shadow-sm mb-2"
            />
            <figcaption className="text-sm text-center text-gray-700">
              Checklist for Tips on Establishing an SCD support group (Click to
              access)
            </figcaption>
          </a>
        </figure>

        <h2 className="text-2xl font-semibold text-[#142841] mb-6">
          CBO Example Documents
        </h2>
        <div className="space-y-8">
          {pdfDownloads.map((pdf, index) => (
            <div
              key={index}
              className="p-6 border border-gray-300 rounded-lg shadow-lg bg-white"
            >
              <h3 className="text-xl font-semibold text-[#142841] mb-3">
                {pdf.title}
              </h3>
              <p className="text-sm text-gray-700 mb-4">
                Review the example document for {pdf.title.toLowerCase()} below,
                or download it directly.
              </p>

              <div className="mt-4 mb-4 h-[32rem] max-w-2xl mx-auto border rounded-md overflow-hidden shadow">
                <object
                  data={pdf.url}
                  type="application/pdf"
                  width="100%"
                  height="100%"
                  aria-label={`Embedded PDF: ${pdf.title}`}
                >
                  <div className="p-4 text-center">
                    <p className="text-red-600 mb-2">
                      It appears your browser doesn&apos;t support embedding
                      PDFs directly.
                    </p>
                    <a
                      href={pdf.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center px-5 py-2.5 text-base font-medium text-center text-white bg-[#A6410A] rounded-lg hover:bg-[#894d35] focus:ring-4 focus:ring-[#A6410A]/50 transition-colors shadow"
                    >
                      Download {pdf.title}
                    </a>
                  </div>
                </object>
              </div>

              <div className="flex flex-col sm:flex-row sm:items-center gap-4 mt-4">
                <a
                  href={pdf.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center px-5 py-2.5 text-base font-medium text-center text-white bg-[#3C2416] rounded-lg hover:bg-opacity-90 focus:ring-4 focus:ring-[#3C2416]/50 transition-colors shadow"
                >
                  Open Document in New Tab
                </a>
                <a
                  href={pdf.url}
                  download
                  className="inline-flex items-center justify-center px-5 py-2.5 text-base font-medium text-center text-[#3C2416] border border-[#3C2416] rounded-lg hover:bg-[#EDE6DE] focus:ring-4 focus:ring-[#3C2416]/50 transition-colors shadow"
                >
                  Download Directly
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* All Done Button */}
      <div className="mt-16 mb-8 text-center">
        <Link
          to="/toolkit/community/community-based-resources" // Link back to parent page
          className="bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-8 py-3 text-lg font-semibold transition-colors duration-200 shadow-lg hover:shadow-xl"
        >
          All done? Click here to return to Community-Based Resources
        </Link>
      </div>
    </ToolkitPageLayout>
  )
}
